var ref = require("prosemirror-model");
var Fragment = ref.Fragment;
var ref$1 = require("prosemirror-transform");
var Transform = ref$1.Transform;
var insertPoint = ref$1.insertPoint;
var ref$2 = require("./selection");
var Selection = ref$2.Selection;

// ::- A selection-aware extension of `Transform`. Use
// [`EditorState.tr`](#state.EditorState.tr) to create an instance.
var EditorTransform = (function (Transform) {
  function EditorTransform(state) {
    Transform.call(this, state.doc)
    this.state = state
    this.curSelection = state.selection
    this.curSelectionAt = 0
    this.selectionSet = false
  }

  if ( Transform ) EditorTransform.__proto__ = Transform;
  EditorTransform.prototype = Object.create( Transform && Transform.prototype );
  EditorTransform.prototype.constructor = EditorTransform;

  var prototypeAccessors = { selection: {} };

  // :: Selection
  // The transform's current selection. This defaults to the
  // editor selection [mapped](#state.Selection.map) through the steps in
  // this transform, but can be overwritten with
  // [`setSelection`](#state.EditorTransform.setSelection).
  prototypeAccessors.selection.get = function () {
    if (this.curSelectionAt < this.steps.length) {
      this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionAt))
      this.curSelectionAt = this.steps.length
    }
    return this.curSelection
  };

  // :: (Selection) → EditorTransform
  // Update the transform's current selection. This will determine the
  // selection that the editor gets when the transform is applied.
  EditorTransform.prototype.setSelection = function setSelection (selection) {
    this.curSelection = selection
    this.curSelectionAt = this.steps.length
    this.selectionSet = true
    return this
  };

  // :: (?Node, ?bool) → EditorTransform
  // Replace the selection with the given node, or delete it if `node`
  // is null. When `inheritMarks` is true and the node is an inline
  // node, it inherits the marks from the place where it is inserted.
  EditorTransform.prototype.replaceSelection = function replaceSelection (node, inheritMarks) {
    var ref = this.selection;
    var $from = ref.$from;
    var $to = ref.$to;
    var from = ref.from;
    var to = ref.to;
    var selNode = ref.node;

    if (node && node.isInline && inheritMarks !== false)
      { node = node.mark(this.state.storedMarks || this.doc.marksAt(from, to > from)) }
    var fragment = Fragment.from(node)

    if (selNode && selNode.isTextblock && node && node.isInline) {
      // Putting inline stuff onto a selected textblock puts it
      // inside, so cut off the sides
      from++
      to--
    } else if (selNode) {
      var depth = $from.depth
      // This node can not simply be removed/replaced. Remove its parent as well
      while (depth && $from.node(depth).childCount == 1 &&
             !$from.node(depth).canReplace($from.index(depth), $to.indexAfter(depth), fragment)) {
        depth--
      }
      if (depth < $from.depth) {
        from = $from.before(depth + 1)
        to = $from.after(depth + 1)
      }
    } else if (node && from == to) {
      var point = insertPoint(this.doc, from, node.type, node.attrs)
      if (point != null) { from = to = point }
    }

    this.replaceWith(from, to, fragment)
    var map = this.mapping.maps[this.mapping.maps.length - 1]
    this.setSelection(Selection.near(this.doc.resolve(map.map(to)), node && node.isInline ? -1 : 1))
    return this
  };

  // :: () → EditorTransform
  // Delete the selection.
  EditorTransform.prototype.deleteSelection = function deleteSelection () {
    return this.replaceSelection()
  };

  // :: (string, from: ?number, to: ?number) → EditorTransform
  // Replace the given range, or the selection if no range is given,
  // with a text node containing the given string.
  EditorTransform.prototype.insertText = function insertText (text, from, to) {
    if ( to === void 0 ) to = from;

    var useSel = from == null
    if (useSel) {
      ;var assign;
      ((assign = this.selection, from = assign.from, to = assign.to))
    }

    var node = text ? this.state.schema.text(text, this.state.storedMarks || this.doc.marksAt(from, to > from)) : null
    if (useSel)
      { this.replaceSelection(node, false) }
    else
      { this.replaceWith(from, to, node) }

    if (text && useSel) {
      var map = this.mapping.maps[this.mapping.maps.length - 1]
      this.setSelection(Selection.findFrom(this.doc.resolve(map.map(to)), -1))
    }
    return this
  };

  // :: (?Object) → TransformAction
  // Create a transform action. `options` can be given to add extra
  // properties to the action object.
  EditorTransform.prototype.action = function action (options) {
    var action = {type: "transform",
                  transform: this,
                  selection: this.selectionSet ? this.selection : null,
                  time: Date.now()}
    if (options) { for (var prop in options) { action[prop] = options[prop] } }
    return action
  };

  // :: () → TransformAction
  // Create a transform action with the `scrollIntoView` property set
  // to true (this is common enough to warrant a shortcut method).
  EditorTransform.prototype.scrollAction = function scrollAction () {
    return this.action({scrollIntoView: true})
  };

  Object.defineProperties( EditorTransform.prototype, prototypeAccessors );

  return EditorTransform;
}(Transform));
exports.EditorTransform = EditorTransform



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-state/dist/transform.js
// module id = 332
// module chunks = 0